import { call, put } from 'redux-saga/effects';
import axios from 'axios';

import * as actions from '../actions/index';
import { alertDialogSetSaga } from './alertDialog';

import { getSessionToken } from '../../constants/session';

const baseUrl = process.env.REACT_APP_API_BASE_URL;
const resource = process.env.REACT_APP_PAYMENTS_OFFERS;

/**
 * GETs a single working capital offer by id from the (non-admin) customer API.
 *
 * The caller is resolved server-side from the bearer claims; the customer path of
 * public.get_working_capital_offer enforces that the caller is a user-group admin and
 * agent and that the offer's payee matches the caller's user group. The offer detail
 * includes its acceptances, each with its repayment installments nested under
 * `repayments`.
 */
export default function* getPaymentsOfferSaga(action) {
    try {
        yield put(actions.paymentsOfferStart());

        const { offerId } = action.data || {};

        if (offerId == null) {
            throw new Error('offerId is required');
        }

        // The single-offer route is a sub-path of the offers resource: /offers/{id}.
        const url = `${baseUrl}${resource}/${offerId}`;

        const sessionToken = getSessionToken();

        const response = yield axios.get(url, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: sessionToken,
            },
        });

        // This endpoint returns the single offer object directly under `result`
        // (i.e. { header, result: {...} }).
        const data = {
            offer: response.data.result ? response.data.result : null,
        };

        yield put(actions.paymentsOfferSuccess(data));
    } catch (error) {
        yield call(alertDialogSetSaga, {
            data: {
                open: true,
                severityLevel: 'error',
                message: error?.response?.data?.error ?? error?.message,
            },
        });
        yield put(actions.paymentsOfferFail(error));
    }
}
